import React from 'react';
import styled from 'styled-components';
import abstract from '../../images/banner-campuscape.png';
import error from '../../images/404error.svg';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${abstract});
  background-size: contain;
  z-index: 1;

  @media (max-width: 800px) {
    position: absolute;
    background-size: cover;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 95vh;
  width: 100vw;

  img {
    width: 320px;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  h1 {
    margin: 0 0 16px 0;
    color: ${props => props.theme.textColor};
    font-size: 36px;
    font-weight: 400;
    text-align: center;
  }

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 400;
    color: ${props => props.theme.alternateTextColor};
    text-align: center;

    a {
      color: ${props => props.theme.accent1Color};
      text-decoration: none;
    }
  }
`;

const InvalidDrive = () => (
  <Wrapper>
    <Container>
      <img src={error} alt="404" />
      <h3>
        Visit <a href="http://www.myanatomy.in/">MyAnatomy</a> to get more
        information.
      </h3>
    </Container>
  </Wrapper>
);

export default InvalidDrive;



// WEBPACK FOOTER //
// ./src/views/NotFound/NotFound.js